import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { CollegeDataService } from 'src/app/services/college-data.service';
import { User } from 'src/app/model/user.model';
import * as XLSX from 'xlsx';
import { BranchDataDTO } from 'src/app/model/branch-data-dto.model';
import { ErrorStatusDialogComponent } from '../error-status-dialog/error-status-dialog.component';
// import { DownloadXlsxComponent } from '../download-xlsx/download-xlsx.component';
import { UtilityService } from 'src/app/services/utility/utility.service';
// import moment = require('moment');
import * as moment from 'moment'
import { ActivatedRoute, Router } from '@angular/router';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { ClipboardService } from 'ngx-clipboard';
import { AddBranchComponent } from '../add-branch/add-branch.component';
import { DownloadXlsxComponent } from '../download-xlsx/download-xlsx.component';

declare interface ObjectConstructor {
  assign(...objects: Object[]): Object;
}

@Component({
  selector: 'app-college-details',
  templateUrl: './college-details.component.html',
  styleUrls: ['./college-details.component.scss']
})
export class CollegeDetailsComponent implements OnInit,AfterViewInit {

  //single: any[];
  //   multi: any[];
  // min=10;
  view: any[] = [undefined, 300];

  count = 0;
  visibilityForLeftIcon = false;
  visibilityForRightIcon = true;
  // options
  // showXAxis = true;


  // this.showXAxis = true;
  // this.showYAxis = true;

  // this.showLegend = true;
  // this.showXAxisLabel = true;
  // this.xAxisLabel = 'Country';
  // this.showYAxisLabel = true;
  // this.yAxisLabel = 'Population';

  // this.colorScheme = {
  //   domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  // };
  // this.gradient = false;


  selectedBranch = "All Progress";
  cards: any;
  collegeId: any;
  details: any[];
  data1: any;
  card: any;
  collegedata: any;
  collegeDetails: any[];
  userInstituteList: any[];
  userBranchWiseList: any[];
  branchId: String = '';
  type: String = '';
  id: String = '';
  data: any = {"branches":[]};
  carddata: any = null;

  arrayBuffer: any;
  excelData: any;
  allUser: User[] = [];
  graphArray = [];
  branchDataDto: BranchDataDTO = new BranchDataDTO();
  excelDownloadData: any = [];
  userArray: any = [];
  userListExcelDownload: User[] = [];
  branchName: any;
  sNoCount: number;
  fullNameCount: number;
  phoneNumberCount: number = 0;
  GenderCount: number;
  emailIdCount: number;
  qualificationCount: number;
  yearOfPassingCount: number;
  permanentCount: number;
  currentPincodeCount: number;
  // excelDownloadModel: any;

  // excelDownloadData = ['S.NO','Name','Mobile Number','Email id','Email id','Year of Passing out','Referred by'];

  single = [];
  second = [

  ];


  barPadding = 20;
  // options
  checkBoxStatus = false;
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = true;
  showYAxisLabel = true;
  xAxisLabel = 'week';
  yAxisLabel = 'Engineers count';
  error: any[];
  errorFieldArray: string[];
  errorFor: string;
  colorScheme = {
    domain: ['#E35F03']
  };
  prevcheckedCollege: any;
  prevCheckedIndex: any;
  //test=[1,2,3,4,5,6,7,8,9,0,12,13,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
  constructor(public dialog: MatDialog,
    private college: CollegeDataService,
    private campaignService: CampaignService,
    private clipboardService: ClipboardService,
    private snackBarService: MatSnackBar,
    private route: ActivatedRoute,
    private excelService: ExcelService,
    private utility: UtilityService,
    private router: Router

  ) {


  }

  ngOnInit() {




    // setTimeout(() => {
    //   window.location.reload();
    // }, 100000); // Activate after 5 minutes.
    // this.refresh();
    // this.campaignService.getCards().subscribe(data => console.log('data in json-->', data)
    // )
    this.type = this.route.snapshot.paramMap.get('type');
    this.id = this.route.snapshot.paramMap.get('id');
    this.getData();
    this.getBranchGraphDetail(this.id);
   
    this.chartSizeCheck();
    this.utility.showSpinner();
    // this.scrollRight(length);
    // this.scrollLeft(length);


    // this.college.currentExcelData.subscribe(response=>
    //   {
    //     this.data = response;
    //     console.log("my data", this.data)
    //     this.carddata = this.data;
    //   });


    this.college.currentMessage.subscribe(response => {
      this.cards = response;
      this.details = this.cards.collegeData;
      // this.uploadResponse();
      this.utility.hideSpinner();

    });

    //location.reload();
    //  this.router.navigateByUrl('collegeDetails/:type/:id')

  }
  ngAfterViewInit() {
    // ...
    
  }
  refresh(): void {
    window.location.reload();
  }




  getBranchGraphDetail(instituteId) {
    this.utility.showSpinner();
    this.campaignService.getGraphDetail(instituteId).subscribe(data => {
    //  console.log('data of graph', data);

      this.userInstituteList = data['data'].userInstitutionList.All;
      this.userBranchWiseList = data['data'].userBranchWiseList.reverse();
   //   console.log(this.userInstituteList);
      this.single = [];
      for (let i = 0; i < this.userInstituteList.length; i++) {
        this.single.push({
          'name': this.userInstituteList[i].weekName,
          'value': this.userInstituteList[i].users.length,
          'users': this.userInstituteList[i].users
        })
      }
      //this.single = this.single.reverse();
      this.single = this.single.slice();
  //    console.log(this.single);
      this.utility.hideSpinner();
    }, err => {
      this.utility.hideSpinner();
  //    console.log('error in graph data', err);

    })
  }


  chartSizeCheck() {
    if (window.innerWidth <= 400) {
      this.barPadding = 10;
    } else if (window.innerWidth <= 800) {
      this.barPadding = 20;
    } else {
      this.barPadding = 60;
    }
  }


  printGraphData(index, college) {
    //console.log('college ', college, 'index       ', index);

    this.branchId = college.id;
    // console.log('branch', this.userBranchWiseList);
    for (let i = 0; i < this.userBranchWiseList.length; i++) {
      if (college.shortName === Object.keys(this.userBranchWiseList[i])[0]) {
        //console.log(i + '-->', this.userBranchWiseList[i]);
        index = i;
      }
    }

    const userArray = this.userBranchWiseList[index][college.shortName];
   // console.log("userArray :", userArray);
    // for (let i = 7; i >= 0; i--) {
    //   let betweenUserArray = this.searchUserBetweenDate(userArray, moment().subtract(7 * (i + 1), 'days').toDate(), moment().subtract(7 * i, 'days').toDate())
    //   this.second[7 - i] = {
    //     'name': moment().subtract(7 * i, 'days').format('DD MMM'),
    //     'value': betweenUserArray.length,
    //     'users': betweenUserArray
    //   }
    // }
    this.second = [];
    for (let i = 0; i < userArray.length; i++) {
      //let betweenUserArray = this.searchUserBetweenDate(userArray, moment().subtract(7 * (i + 1), 'days').toDate(), moment().subtract(7 * i, 'days').toDate())
      // this.second[7 - i] = {
      //   'name': moment().subtract(7 * i, 'days').format('DD MMM'),
      //   'value': betweenUserArray.length,
      //   'users': betweenUserArray
      // }

      this.second.push({
        'name': userArray[i].weekName,
        'value': userArray[i].users.length,
        'users': userArray[i].users
      })

    }


  //  console.log(this.single);
    this.single = [];
  //  console.log(this.second);
    this.single = this.second.slice();
   // console.log('After ', this.single);

  }


  // how many user are between this date
  searchUserBetweenDate(userArray, fromDate: Date, toDate: Date): any {
    let object = []
  //  console.log(userArray);
    if (userArray.length > 0)
      for (let i = 0; i < userArray.length; i++) {
        let userDate = moment(userArray[i].registeredDate).toDate()
        // console.log(moment("2014-02-27T10:00:00").toDate().getTime(), '           ', moment("2014-02-27T10:00:00").format('DD-MMM-YYYY'));
        if (userDate > fromDate && userDate < toDate) {
          object.push(userArray[i]);
        }

      }
    return object;
  }
  setAllUserGraphData(index, college) {
  //  console.log('setAllUserGraphData runs', index, '      ', college);
    this.single = [];
  //  console.log("this.userInstituteList:  -------->", this.userInstituteList);

    for (let i = 0; i < this.userInstituteList.length; i++) {
      this.single.push({
        'name': this.userInstituteList[i].weekName,
        'value': this.userInstituteList[i].users.length,
        'users': this.userInstituteList[i].users
      })
    }
    // this.single = this.single.reverse();
    this.single = this.single.slice();
  //  console.log(this.single);

  }


  copyUrl(url) {
    this.clipboardService.copyFromContent(url);
    this.snackBarService.open('Copied to clipboard', '', { duration: 2000 });

  }


  getData() {

    this.utility.showSpinner();
    this.campaignService.getDetailsByTypeAndId(this.type, this.id)
      .subscribe(response => {

   //     console.log("TypeandId", response);
        this.data = (response as any).data;
    //    console.log("my data", this.data);
        this.carddata = this.data;
        // console.log("my data1", this.carddata);
        for (let i = 0; i < this.data.branches.length; i++) {
          if (this.data.branches[i].address.length > 100) {
            this.data.branches[i].address = this.data.branches[i].address.slice(0, 100);
            this.data.branches[i].address = this.data.branches[i].address + '...';

          }
          // console.log(this.data.branches[i].address);
        }
        this.checkboxClick(this.prevCheckedIndex, this.prevcheckedCollege, event)
        this.utility.hideSpinner();
      });

  }



  openBranch(data) {
    const dialogRef = this.dialog.open(AddBranchComponent, {
      data: data,
      panelClass: "dialog-style",
      width: '50em',
      disableClose: true
    })

    dialogRef.afterClosed().subscribe(result => {
      this.getData();
  //    console.log(`Dialog result: ${result}`);
      // console.log(result);
      if (result != null) {
        this.getData();
      }
    });
  }



  // tslint:disable-next-line: member-ordering
  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;

  public scrollRight(length): void {
  //  console.log("Length", length);
    this.count++;
    if (this.count + 2 === length - 1) {
  //    console.log("this.count", this.count + 2);
  //    console.log("Length", length);
      this.visibilityForRightIcon = false;
      this.visibilityForLeftIcon = true;
    }
    else {
      this.visibilityForLeftIcon = true;
    }

    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 313), behavior: 'smooth' });
    // this.widgetsContent.nativeElement.scrollTo({ right: (this.widgetsContent.nativeElement.scrollRight + 270), behavior: 'smooth' });
  }

  public scrollLeft(length): void {
    this.count--;
    if (this.count + 2 === 2) {
      this.visibilityForLeftIcon = false;
      this.visibilityForRightIcon = true;
    }
    else {
      this.visibilityForRightIcon = true;
    }
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 313), behavior: 'smooth' });
  }

  uploadResponse() {
    this.campaignService.getError().subscribe(response => {
    //  console.log(response);
      if (response.validationStatus === true) {
        this.dialog.open(ErrorStatusDialogComponent, {
          width: '60%',
          data: response
        });
      }
      if (response.validationStatus === false) {

      }
    });
  }

  // method to handle uploading excel data
  uploadHandler(event, college: any) {
    this.allUser = [];
    this.sNoCount = 0;
    this.fullNameCount = 0;
    this.phoneNumberCount = 0;
    this.GenderCount = 0;
    this.emailIdCount = 0;
    this.qualificationCount = 0;
    this.yearOfPassingCount = 0;
    this.permanentCount = 0;
    this.currentPincodeCount = 0;
    this.errorFieldArray = [];
   // console.log('id', college.id);
   // console.log('branch', college.branchName);

    //  this.utility.showSpinner();
    const file: File = event.target.files[0];
    event.target.value = null;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    // console.log('file',file);

    fileReader.onload = () => {

      this.arrayBuffer = fileReader.result;
      const tempData = new Uint8Array(this.arrayBuffer);
      const arr = new Array();

      for (let i = 0; i !== tempData.length; ++i) {
        arr[i] = String.fromCharCode(tempData[i]);
      }

      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];

      this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      console.log('type of excel-->', this.excelData);

      for (const value of this.excelData) {
        console.log('value--->', value);

        const user: User = new User();
        user.rowNumber = value['S.NO'];
        if (user.rowNumber === undefined) {
          this.sNoCount++;
        }
        user.fullName = value['Full Name'];
        if (user.fullName === undefined) {
          this.fullNameCount++;
        }
        user.phoneNumber = value['Phone Number'];

        // console.log('phnum',user.phoneNumber);
        if (user.phoneNumber === undefined) {
          console.log('number-->', this.phoneNumberCount);
          this.phoneNumberCount++;
        }
        user.gender = value.Gender;
        if (user.gender === undefined) {
          this.GenderCount++;
        }
        user.emailId = value['Email id'];
        if (user.emailId === undefined) {
          this.emailIdCount++;
        }
        user.qualification = value.Qualification;
        if (user.qualification === undefined) {
          this.qualificationCount++;
        }
        user.graduationYear = value['Year Of Passing'];
        if (user.graduationYear === undefined) {
          this.yearOfPassingCount++;
        }
        user.permanentPinCode = value['Permanent Pin Code'];
        if (user.permanentPinCode === undefined) {
          this.permanentCount++;
        }
        user.currentPinCode = value['Current Pin Code'];
        if (user.currentPinCode === undefined) {
          this.currentPincodeCount++;
        }
        this.allUser.push(user);
      }

      if (this.phoneNumberCount === this.allUser.length) {
        // console.log('phone number column in excel sheet invalid');
        // this.snackBarService.open('phone number column in excel sheet invalid', 'close',{duration: 5000});
        this.errorFieldArray.push('Phone Number');
      }
      if (this.sNoCount === this.allUser.length) {
        this.errorFieldArray.push('sr. No');
        //  this.snackBarService.open('s.no column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.fullNameCount === this.allUser.length) {
        this.errorFieldArray.push('Full Name');
        // this.snackBarService.open('full name column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.GenderCount === this.allUser.length) {
        this.errorFieldArray.push('Gender');
      }
      if (this.emailIdCount === this.allUser.length) {
        this.errorFieldArray.push('Email id');
      }
      if (this.qualificationCount === this.allUser.length) {
        this.errorFieldArray.push('Qualification');
        //this.snackBarService.open('qualification column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.yearOfPassingCount === this.allUser.length) {
        this.errorFieldArray.push('Year Of Passing');

      }
      if (this.permanentCount === this.allUser.length) {
        this.errorFieldArray.push('Permanent Pin Code');
        // this.snackBarService.open('permanent pin code column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.currentPincodeCount === this.allUser.length) {
        this.errorFieldArray.push('Current Pin Code')
        //this.snackBarService.open('current pin code column invalid in excel sheet', 'close', {duration: 5000});
      }


      if (this.errorFieldArray.length != 0) {
        console.log('error in column-->', this.errorFieldArray);

        this.dialog.open(ErrorStatusDialogComponent, {
          width: '60%',
          data: {
            response: this.errorFieldArray,
            errorFor: 'column'
          }
        });
      }
      else {
        console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));

        // console.log('all user', this.allUser);
        this.branchDataDto.users = this.allUser;
        this.branchDataDto.branchId = college.id;
        console.log('all user', this.branchDataDto.users);
        console.log('got id', this.branchDataDto.branchId);
        console.log('excel data to upload--->', this.branchDataDto);
        this.campaignService.postExcelData(this.branchDataDto).subscribe(
          response => {
            this.utility.hideSpinner();
            console.log(response);
            // this.branchDataDto = null;
            this.allUser = [];
            if (response.data.validationStatus === true) {
              this.dialog.open(ErrorStatusDialogComponent, {
                width: '60%',
                data: {
                  response: response,
                  errorFor: 'row'
                }
              });
            }
            if (response.data.validationStatus === false) {
              this.snackBarService.open('excel sheet upload successfully', 'close', {
                duration: 4000,
                panelClass: ['snackbar']
              });

            }
            // this.ngOnInit();
            this.getBranchGraphDetail(this.id);

          }
        );
      }
    };
  }

  openGrapDialog(event) {
    console.log("event open diaolog----> ", event);
    console.log("this.singlw : ", this.single);
    console.log("userlist : ", this.userInstituteList);


    // console.log(event, this.userInstituteList, this.single);
    const dialogRef = this.dialog.open(DownloadXlsxComponent, {
      width: '400px',
      disableClose: true,

    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("result: ", result);

      if (result) {
        if (event.name.substring(0, 1) !== 'w') {
          for (let i = 0; i < this.userInstituteList.length; i++) {
            if (this.userInstituteList[i].weekName == event.name) {

              // this.excelService.exportAsExcelFile(this.userInstituteList[i].users, this.userInstituteList[i].weekName + '_users');
              this.downloadHandler(this.userInstituteList[i].users, this.userInstituteList[i].weekName + '_users');
              return;
            }

          }
        } else {
          console.log(this.userBranchWiseList);

          for (let i = 0; i < this.single.length; i++) {
            if (this.single[i].name === event.name) {
              // this.excelService.exportAsExcelFile(this.single[i].users, this.single[i].name + '_users');
              this.downloadHandler(this.single[i].users, this.single[i].name + '_users');
              return;
            }

          }
        }
      }
      console.log(`Dialog result: ${result}`);
    });
  }


  // method to download excel file
  async downloadHandler(values: any, name: any) {
    console.log("Values", values);
    await this.getData();
    //  this.ngOnInit();
    // this.college.getData();
    const fileName: any = this.data.institutionName + '-' + name;
    this.userListExcelDownload = values;

    if (values.length === 0) {
      const excelDownloadModel: any = new class {
        'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
        'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': ''; 'Campaign Short Name': '';
      };


      excelDownloadModel['S.NO'] = '';
      excelDownloadModel['Full Name'] = '';
      excelDownloadModel['Phone Number'] = '';
      excelDownloadModel['Gender'] = '';
      excelDownloadModel['Email id'] = '';
      excelDownloadModel['Qualification'] = '';
      excelDownloadModel['Year Of Passing'] = '';
      excelDownloadModel['Registered Date'] = '';
      excelDownloadModel['Permanent Pin Code'] = '';
      excelDownloadModel['Current Pin Code'] = '';
      excelDownloadModel['Campaign Short Name'] = '';
      excelDownloadModel['Refferal Name'] = '';
      excelDownloadModel['Refferal Contact No'] = '';
      this.excelDownloadData.push(excelDownloadModel);
      this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
    } else {

      let rowNumber: number = 0;

      for (const response of this.userListExcelDownload) {
        const excelDownloadModel: any = new class {
          'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
          'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': ''; 'Campaign Short Name': ''; 'Refferal Name': ''; 'Refferal Contact No': '';
        };
        excelDownloadModel['S.NO'] = ++rowNumber;
        excelDownloadModel['Full Name'] = response.fullName;
        excelDownloadModel['Phone Number'] = response.phoneNumber;
        excelDownloadModel['Gender'] = response.gender;
        excelDownloadModel['Email id'] = response.emailId;
        excelDownloadModel['Qualification'] = response.qualification;
        excelDownloadModel['Year Of Passing'] = response.graduationYear;
        excelDownloadModel['Registered Date'] = response.registeredDate;
        excelDownloadModel['Permanent Pin Code'] = response.permanentPinCode;
        excelDownloadModel['Current Pin Code'] = response.currentPinCode;
        excelDownloadModel['Campaign Short Name'] = response.campaignShortName;
        excelDownloadModel['Refferal Name'] = response.referralName;
        excelDownloadModel['Refferal Contact No'] = response.referralContactNumber;
        this.excelDownloadData.push(excelDownloadModel);
      }
      this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
    }
    this.excelDownloadData = [];
  }

  // checkboxClick(index, college,val) {
  //   this.checkBoxStatus = !this.checkBoxStatus;
  //   this.branchId = '';
  //   if (this.checkBoxStatus === false) {
  //     this.xAxisLabel = 'week';
  //     this.setAllUserGraphData(index, college);
  //   }
  //   if (this.checkBoxStatus === true) {
  //     this.xAxisLabel = 'date';
  //     this.printGraphData(index, college);
  //   }
  // }

  checkboxClick(index, college, event) {

    this.prevCheckedIndex = index;
    this.prevcheckedCollege = college;

    if (college != undefined) {
      let checked = college.checked;
      console.log("data for graph: ", college);

      for (let i = 0; i < this.data.branches.length; i++) {
        this.data.branches[i].checked = false;
        if (this.data.branches[i].id == college.id) {
          this.data.branches[i].checked = checked;
        }
      }

      // this.checkBoxStatus = !this.checkBoxStatus;
      if (checked === false) {
        //alert("in");
        this.selectedBranch = "All Progress";
        this.xAxisLabel = 'week';
        this.setAllUserGraphData(index, college);
      }
      if (checked === true) {
        this.selectedBranch = college.branchName + " Progress";
        this.xAxisLabel = 'week';
        this.printGraphData(index, college);
      }
    }
  }
}
